export default __webpack_public_path__ + "static/01-8718465f410144d7a6d3c104968db471.png";